import styled from 'styled-components';
import ComputerIcon from '@/assets/mo/computer.svg?react';
import SalesIcon from '@/assets/mo/sales.svg?react';
import ArrowBrownIcon from '@/assets/mo/arrow-brown.svg?react';
// import CommunicationIcon from '@/assets/mo/communication.svg?react';

const UploadGuideCard = () => {
  return (
    <ThirdCard>
      <CardContent>
        <CardTitleRow>
          <ComputerIcon />
          <CardTitle>파일을 업로드해주세요</CardTitle>
        </CardTitleRow>
        <CardDescription>
          안내문자, 진단서 등 다양한 파일을 업로드만 하면 어떻게 대응해야할 지 알려드릴게요
        </CardDescription>
      </CardContent>
      <GuideBoxWrapper>
        <GuideBox>
          <GuideText>보험금을 잘 받았는지 걱정이 된다면</GuideText>
          <GuideBottomRow>
            <SalesIconWrapper>
              <SalesIcon />
            </SalesIconWrapper>
            <ArrowButton
              onClick={() => window.open('https://allbadeum.wixsite.com/my-site-1', '_blank')}
            >
              <ArrowBrownIcon />
            </ArrowButton>
          </GuideBottomRow>
        </GuideBox>
        {/* <MessageBox>
          <MessageText>
            보험사에서 <br /> 문자를 받았을 때
          </MessageText>
          <GuideBottomRow>
            <SalesIconWrapper>
              <CommunicationIcon />
            </SalesIconWrapper>
            <ArrowButton
              onClick={() => (window.location.href = 'https://www.hiadjuster.com/reading')}
            >
              <ArrowBrownIcon />
            </ArrowButton>
          </GuideBottomRow>
        </MessageBox> */}
      </GuideBoxWrapper>
    </ThirdCard>
  );
};

export default UploadGuideCard;

const ThirdCard = styled.div`
  display: flex;
  width: 100%;
  padding: 30px 19px;
  flex-direction: column;
  align-items: flex-start;
  gap: 32px;
  border-top: 1px solid var(--button-solid-solid02, #f4f4f4);
  border-bottom: 1px solid var(--button-solid-solid02, #f4f4f4);
  background: var(--Primary-white, #fff);
  backdrop-filter: blur(1.5px);
`;

const CardContent = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  align-self: stretch;
`;

const CardTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
`;

const CardTitle = styled.div`
  color: var(--gray-ui_gray01, #191919);
  font-size: 18px;
  font-style: normal;
  font-weight: 700;
  line-height: 150%;
  letter-spacing: -0.36px;
`;

const CardDescription = styled.p`
  align-self: stretch;
  color: var(--gray-ui_gray03, #3a3a3a);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
  letter-spacing: -0.28px;
  text-align: start;
`;

const GuideBoxWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
  align-self: stretch;
`;

const GuideBox = styled.div`
  display: flex;
  height: 132px;
  padding: 14px 16px;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  flex: 1 0 0;
  border-radius: 8px;
  background: #f9ecd3;
`;

// const MessageBox = styled.div`
//   display: flex;
//   height: 132px;
//   padding: 14px 16px;
//   flex-direction: column;
//   justify-content: space-between;
//   align-items: flex-start;
//   flex: 1 0 0;
//   border-radius: 8px;
//   background: #d3d4f9;
// `;

const GuideText = styled.div`
  align-self: stretch;
  color: #7b4800;
  font-family: 'Spoqa Han Sans Neo';
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: 150%; /* 21px */
  letter-spacing: -0.28px;
  text-align: start;
`;

// const MessageText = styled.div`
//   align-self: stretch;

//   color: #29007b;
//   text-align: start;
//   font-family: 'Spoqa Han Sans Neo';
//   font-size: 14px;
//   font-style: normal;
//   font-weight: 500;
//   line-height: 150%; /* 21px */
//   letter-spacing: -0.28px;
// `;

const GuideBottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-self: stretch;
`;

const SalesIconWrapper = styled.div`
  display: flex;
  width: 34px;
  height: 34px;
  padding: 1.669px;
  align-items: center;
  gap: 4.173px;
  aspect-ratio: 1 / 1;
`;

const ArrowButton = styled.div`
  display: flex;
  padding: 8px;
  align-items: center;
  gap: 10px;
  border-radius: 99px;
  background:
    linear-gradient(0deg, rgba(255, 255, 255, 0.2) 0%, rgba(255, 255, 255, 0.2) 100%), #fff;
`;
